import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-edit\"><path d=\"M1.667 16.786h16.667v1.19H1.667v-1.19Zm13.929-10.12a1.15 1.15 0 0 0 0-1.666l-2.143-2.143a1.15 1.15 0 0 0-1.667 0l-8.929 8.929v3.81h3.81l8.929-8.93ZM12.619 3.69l2.143 2.143-1.786 1.786-2.142-2.143 1.785-1.786ZM4.048 14.405v-2.143L10 6.31l2.143 2.142-5.952 5.953H4.048Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol